/**
 *  @class
 *  @function CustomDots
 */
if (!customElements.get('custom-dots')) {
  class CustomDots extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const control = this.getAttribute("aria-controls")
			this.scroll = document.getElementById(control)
			
      this.dots.forEach(dot => {
        dot.addEventListener("click", () => {
          this.clickDot.bind(this)(dot)
        })
      })
      this.currentIndex = 0
      this.scroll.addEventListener('scroll', (event)=>{
        const pageWidth = this.scroll.clientWidth;
        if( this.scroll.scrollWidth - event.target.scrollLeft - pageWidth < 5){
          this.currentIndex = this.dots.length - 1
        }else if(event.target.scrollLef == 0){
          this.currentIndex = 0
        }else{
          this.currentIndex = Math.round(event.target.scrollLeft/pageWidth)
        }
        if(this.dots && this.dots[this.currentIndex]){
          ;[].forEach.call(this.dots, function (el) {
            el.classList.remove('active')
          })

          this.dots[this.currentIndex].classList.add("active")
        }
      });

      let startX = null;

      this.scroll.addEventListener('mousedown', (e) => {
        startX = e.clientX;
      });

      this.scroll.addEventListener('mousemove', (e) => {
        if (startX !== null) {
          const endX = e.clientX;
          const deltaX = endX - startX;

          if (Math.abs(deltaX) > 30) {
            if (deltaX > 0) {
              this.next()
            } else {
              this.prev()
            }
            startX = null; 
          }
        }
      });

      this.scroll.addEventListener('mouseup', () => {
        startX = null;
      });

      this.scroll.addEventListener('mouseleave', () => {
        startX = null;
      });

      
    }
    get dots(){
      return Array.from(this.querySelectorAll('.custom--dots-item'));
    }
    
    clickDot(dot){
      if(!dot.classList.contains("active")){
        const pageWidth = this.scroll.clientWidth;
        this.scroll.scrollTo({
          left: pageWidth * dot.dataset.index,
          behavior: "smooth"
        });
        const nextEle = this.dots[this.currentIndex + 1];
        if(!nextEle ){
          this.nextControl && this.nextControl.classList.add("disabled")
        }else{
          this.nextControl && this.nextControl.classList.remove("disabled")
        }
        const prevEle = this.dots[this.currentIndex - 1];
        if(!prevEle ){
          this.prevControl && this.prevControl.classList.add("disabled")
        }else{
          this.prevControl && this.prevControl.classList.remove("disabled")
        }

      }
    }
    prev(){
      const prevEle = this.dots[this.currentIndex - 1];
      if(prevEle ){
        this.currentIndex = this.currentIndex - 1
        this.clickDot(prevEle)
      }
    }

    next(){
      const nextEle = this.dots[this.currentIndex + 1];
      if(nextEle ){
        this.currentIndex = this.currentIndex + 1
        this.clickDot(nextEle)
      }
    }

  }
  customElements.define('custom-dots', CustomDots);
}